import { render, staticRenderFns } from "./ResumoPacientesCadastrados.vue?vue&type=template&id=b2111266&scoped=true"
import script from "./ResumoPacientesCadastrados.vue?vue&type=script&lang=js"
export * from "./ResumoPacientesCadastrados.vue?vue&type=script&lang=js"
import style0 from "./ResumoPacientesCadastrados.vue?vue&type=style&index=0&id=b2111266&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2111266",
  null
  
)

export default component.exports